import React from 'react';
import Cabecalho from './cabecalho/Cabecalho';
import Rodape from './Rodape';

export default function PublicPageLayout({ children }) {
  return (
    <div className="App public-site">
      <Cabecalho />
      <main>{children}</main>
      <Rodape />
    </div>
  );
}
